import { filterType } from "./api-types";

export const SET_FILTERS = 'SET_FILTERS';
export const GET_CATEGORY_DISTRIBUTION_SUCCESS = "GET_CATEGORY_DISTRIBUTION_SUCCESS"
export const GET_CATEGORY_DISTRIBUTION = "GET_CATEGORY_DISTRIBUTION"
export const GET_SEBI_ASSET_ALLOCATION_SUCCESS = "GET_SEBI_ASSET_ALLOCATION_SUCCESS"
export const GET_SEBI_ASSET_ALLOCATION = "GET_SEBI_ASSET_ALLOCATION"
export const GET_AMC_PRODUCTS_PERFORMANCE_SUCCESS = "GET_AMC_PRODUCTS_PERFORMANCE_SUCCESS"
export const GET_AMC_PRODUCTS_PERFORMANCE = "GET_AMC_PRODUCTS_PERFORMANCE"
export const GET_SCHEME_DETAILS_SUCCESS = "GET_SCHEME_DETAILS_SUCCESS"
export const GET_SCHEME_DETAILS = "GET_SCHEME_DETAILS"
export const GET_TOP_10_SCHEMES_SUCCESS = "GET_TOP_10_SCHEMES_SUCCESS"
export const GET_TOP_10_SCHEMES = "GET_TOP_10_SCHEMES"
export const TOTAL_CARD_VALUES_SUCCESS = "TOTAL_CARD_VALUES_SUCCESS"
export const TOTAL_CARD_VALUES = "TOTAL_CARD_VALUES"
export const PORTFOLIO_EXPOSURE_MF_SUCCESS = "PORTFOLIO_EXPOSURE_MF_SUCCESS"
export const PORTFOLIO_EXPOSURE_MF = "PORTFOLIO_EXPOSURE_MF"
export const MARKET_CAP_ALLOCATION_SUCCESS = "MARKET_CAP_ALLOCATION_SUCCESS"
export const MARKET_CAP_ALLOCATION = "MARKET_CAP_ALLOCATION"
export const RATING_AND_MATURITY_SUCCESS = "RATING_AND_MATURITY_SUCCESS"
export const RATING_AND_MATURITY = "RATING_AND_MATURITY"
export const GET_QUANTITATIVE_ANALYSIS_SUCCESS = "GET_QUANTITATIVE_ANALYSIS_SUCCESS"
export const GET_QUANTITATIVE_ANALYSIS = "GET_QUANTITATIVE_ANALYSIS"
export const GET_ISSUER_CATEGORY_SUCCESS = "GET_ISSUER_CATEGORY_SUCCESS"
export const GET_ISSUER_CATEGORY = "GET_ISSUER_CATEGORY"
export const PERFORMANCE_NAV_CHART_SUCCESS = "PERFORMANCE_NAV_CHART_SUCCESS"
export const PERFORMANCE_NAV_CHART = "PERFORMANCE_NAV_CHART"
export const GET_TRANSACTION_DETAILS_SUCCESS = "GET_TRANSACTION_DETAILS_SUCCESS"
export const GET_TRANSACTION_DETAILS = "GET_TRANSACTION_DETAILS"
export const AMC_PERFORMANCE_DOWNLOAD_SUCCESS = "AMC_PERFORMANCE_DOWNLOAD_SUCCESS"
export const AMC_PERFORMANCE_DOWNLOAD = "AMC_PERFORMANCE_DOWNLOAD"
export const SECTOR_ALLOCATION_SUCCESS = "SECTOR_ALLOCATION_SUCCESS"
export const SECTOR_ALLOCATION = "SECTOR_ALLOCATION"
export const GET_FUND_HOUSE_PERFORMANCE_SUCCESS = "GET_FUND_HOUSE_PERFORMANCE_SUCCESS"
export const GET_FUND_HOUSE_PERFORMANCE = "GET_FUND_HOUSE_PERFORMANCE"
export const GET_HOLDING_DETAILS_FILTER_SUCCESS = "GET_HOLDING_DETAILS_FILTER_SUCCESS"
export const GET_HOLDING_DETAILS_FILTER = "GET_HOLDING_DETAILS_FILTER"
export const CREDIT_RATING_SUCCESS = "CREDIT_RATING_SUCCESS"
export const CREDIT_RATING = "CREDIT_RATING"
export const BENCHMARK_PERFORMANCE_SUCCESS = "BENCHMARK_PERFORMANCE_SUCCESS"
export const BENCHMARK_PERFORMANCE = "BENCHMARK_PERFORMANCE"
export const ASSET_CLASS_DETAILS_SUCCESS = "ASSET_CLASS_DETAILS_SUCCESS"
export const ASSET_CLASS_DETAILS = "ASSET_CLASS_DETAILS"

export type FILTERS_TYPE = {
  title: string;
  key: string;
  options: ({ label: string; value: string } | string)[];
}[];

export type CategoryWiseDistributionReq = {
  rmId: string;
  sortItem: string;
  order: string;
  clientCode?: string;
  portfolioId?: string;
  assetGroup?: string;
}

export type rmID = {
  rmId: string;
}

export interface SebiAssetAllocationReq {
  rmId: string;
  clientCode?: string;
  portfolioId?: string;
  assetGroup?: string;
}

export type CategoryWiseObjItems = {
  categoryType: string;
  investedValue: number;
  marketValue: number;
  dividend: number;
  unRelease: number;
  release: number;
  irr: number;
  schemes: number;
}

export type CategoryWiseDistibutionRes = {
  result: {
    categoryWiseDistribution: {
      labelData: filterType[];
      data: Array<Array<string | number>>;
      totalValue: filterType;
    },
    categoryWiseBreakup: Array<CategoryWiseObjItems>
  },
  message: string;
  isSuccess: boolean;
}

export type SebiAssetAllocationRes = {
  result: {
    labelData: filterType[];
    data: Array<Array<string>>;
    totalValue: filterType;
  },
  message: string;
  isSuccess: boolean;
}

export type AMCPerformanceProductsReq = {
  rmId: string;
  sortItem: string;
  order: string;
  category?: string;
  clientCode?: string;
  portfolioId?: string;
  assetGroup?: string;
}

export type amcAnalysis = {
  amcname: string;
  marketValue: number;
  equity: number;
  debt: number;
  hybrid: number;
  others: number;
  investedValue: number;
  unRelease: number;
  irr: number;
  holdings: number;
}

export type AMCPerformanceProductsRes = {
  result: Array<amcAnalysis>,
  message: string;
  isSuccess: boolean;
}

export interface GetSchemeDetailsRequestBody {
  rmId: string | number;
  sortItem: string;
  order: string;
  currentPage: number;
  rowsPerPage: number;
  clientCode?: string;
  portfolioId?: string;
  assetGroup?: string;
}

export interface SchemeDetailsObj {
  isSuccess: boolean;
  data: SchemeDetail[]
}

export interface SchemeDetail {
  amcId?: string;
  schemeName: string;
  folioNo: string;
  investedValue: number;
  marketValue: number;
  categoryName: string;
  schemeLogo: string;
  percentage: {
    amount: number;
    percentage: number;
  };
  companyName?: string;
  units?: number;
  realGainLossPercentage?: {
    amount?: number;
    percentage?: number;
  },
  inflow?: number;
  outflow?: number;
  exposure?: number;
  noOfShares?: number;
  shares1Year?: string;
  avgCostPrice?: number;
  week52High?: number;
  week52Low?: number;
  eps?: number;
  pe?: number;
  pb?: number;
  marketCapitalisation?: number;
  dividend?: number;
  sectorPE?: number;
  currentPrice?: number;
  expenseRatio?: number;
  investedOn?: string;
  periodOfInvestment?: number;
  irr?: number;


}

export interface GetSchemeDetailsResponseBody {
  result: SchemeDetail[];
  message: string;
  isSuccess: boolean;
  totalLength: number;
}

export interface GetTop10SchemesReq {
  rmId: string;
  category: string;
  clientCode?: string;
  portfolioId?: string;
  assetGroup?: string;
  isTop?: boolean;
}

export type Scheme10Obj = {
  schemeName: string;
  sector: string;
  amount: number;
  exposure: number;
  category?: string;
  fundHouse?: string;
  return?: number;
  fundType?: string;
  investedValue?: number;
  unRelGainLoss?: number;
}
export interface GetTop10SchemesRes {
  result: {
    topSchemes: {
      data: Array<Scheme10Obj>
    }
  };
  message: string;
  isSuccess: boolean;
}

export interface TotalCardValuesReq {
  rmId: string;
  category: string;
  clientCode?: string;
  portfolioId?: string;
  assetGroup: string;
}

export interface TotalCardValuesRes {
  result: {
    totalInvestedValue: number;
    totalMarketValue: number;
    gainLoss: number
    totalInvestors: number;
    percentage: number;
    irr: number
  };
  message: string;
  isSuccess: boolean;
}

export interface PortfolioExposureMFReq {
  rmId: string;
  clientCode?: string;
  category?: string;
  filter: string | number;
  portfolioId?: string;
  assetGroup?: string;
}

export interface PortfolioExposureMFRes {
  result: {
    labelData: filterType[];
    data: Array<Array<string>>;
    totalValue: filterType;
  },
  message: string;
  isSuccess: boolean;
}

export interface MarketCapAllocationReq {
  clientCode?: string;
  rmId: string;
  category?: string;
  portfolioId?: string;
  assetGroup?: string;
}

export interface MarketCapAllocationRes {
  result: {
    labelData: filterType[];
    data: Array<Array<string>>;
    totalValue: filterType;
  },
  message: string;
  isSuccess: boolean;
}

export interface RatingAndMaturityReq {
  rmId: string;
  clientCode?: string;
  category?: string;
  filter?: string | number;
  portfolioId?: string;
  assetGroup?: string;
}

export interface RatingAndMaturityRes {
  result: {
    labelData: filterType[];
    data: Array<Array<string>>;
    totalValue: filterType;
  },
  message: string;
  isSuccess: boolean;
}

export interface IssuerCategoryReq {
  rmId: string;
  clientCode?: string;
  category?: string;
  filter?: string | number;
  portfolioId?: string;
  assetGroup?: string;
}

export interface IssuerCategoryRes {
  result: {
    labelData: filterType[];
    data: Array<Array<string>>;
    totalValue: filterType;
  },
  message: string;
  isSuccess: boolean;
}
export interface GetQuantitativeAnalysisRequestBody {
  rmId: string;
  clientCode?: string;
  category?: string;
  portfolioId?: string;
  assetGroup?: string;
}

export interface QuantitativeAnalysisData {
  amcname: string;
  holding: number;
}

export interface GetQuantitativeAnalysisResponseBody {
  result: Array<QuantitativeAnalysisData>;
  message: string;
  isSuccess: boolean;
}

export interface performanceNavChartReq {
  rmId: string;
  clientCode?: string;
  portfolioId?: string;
  assetGroup?: string;
}

export interface PerformanceNavChartRes {
  result: {
    data1: Array<[number, number]>;
    data2: Array<[number, number]>;
    label1: string;
    label2: string;
    value1: number;
    value2: number;
  },
  message: string;
  isSuccess: boolean;
}

export interface GetTransactionDetailsRequestBody {
  rmId: string | number;
  sortItem: string;
  order: string;
  currentPage: number;
  rowsPerPage: number;
}

export interface TransactionDetailsData {
  schemeName: string;
  schemeCategory: string;
  amount: string;
  type: string;
  date: string;
  units: number | string | null;
}

export interface GetTransactionDetailsResponseBody {
  result: Array<TransactionDetailsData>;
  totalLength: number;
  message: string;
  isSuccess: boolean;
}

export interface AmcPerformanceDownloadReq {
  jsonData: any
  sheetName: string;
}

export interface SectorAllocationRequestData {
  rmId: string;
  clientCode: string;
  portfolioId: string;
  assetGroup: string;
}

interface SectorAllocationData {
  data: Array<Array<number | string>>;
  labelData: filterType[];
  totalValue: filterType
}

export interface SectorAllocationResponseData {
  result: SectorAllocationData;
  message: string;
  isSuccess: boolean;
}

export interface GetFundHousePerformanceRequestData {
  rmId: string;
  sortItem: string;
  order: string;
  assetGroup: string;
  currentPage: number;
  rowsPerPage: number;
  clientCode: string;
  portfolioId: string;
}

interface FundHousePerformanceData {
  fundHouseId: string;
  fundHouseName: string;
  investedValue: number;
  marketValue: number;
  unRelGainLoss: number;
}

export interface GetFundHousePerformanceResponseData {
  result: FundHousePerformanceData[];
  totalLength: number;
  message: string;
  isSuccess: boolean;
}

interface HoldingDetailsFilterData {
  category: string;
  filters: {
    id: string;
    value: string;
  }[];
}

export type GetHoldingDetailsFilterResponseBody = Array<HoldingDetailsFilterData>

export interface CreditRatingReq {
  rmId: string;
  clientCode?: string;
  portfolioId?: string;
  assetGroup?: string;
  filter?: string | number;
}

export interface CreditRatingRes {
  result: {
    labelData: filterType[];
    data: Array<Array<string>>;
    totalValue: filterType;
  },
  message: string;
  isSuccess: boolean;
}

export interface BenchmarkPerformanceReq {
  rmId: string;
  clientCode?: string;
  portfolioId?: string;
  assetGroup?: string;
}

export interface BenchmarkPerformanceRes {
  result: {
    data1: Array<[number, number]>;
    data2: Array<[number, number]>;
    data3: Array<[number, number]>;
    data4: Array<[number, number]>;
    data5: Array<[number, number]>;
    label1: string;
    label2: string;
    label3: string;
    label4: string;
    label5: string;
  },
  message: string;
  isSuccess: boolean;
}

export interface AssetClassDetailsReq {
  rmId: string;
  clientCode?: string;
  portfolioId?: string;
}

export interface AssetClassDetailsRes {
  result: {
    mutual_funds: number;
    direct_equity: number;
    pms: number;
    debt: number;
    alternates: number;
  },
  message: string;
  isSuccess: boolean;
}

